export default "__VITE_PUBLIC_ASSET__3cadf1ee__"